export default [
  {
    header: "تشبيك",
    icon: "SlackIcon",
    children: [
      {
        title: "امنح",
        route: "tashbeek-give",
        icon: "SlackIcon",
        slug: "ngo_assists",
      },
      {
        title: "استفد",
        route: "tashbeek-benfit",
        icon: "SlackIcon",
        slug: "ngo_assists",
      },
      {
        title: "إدارة واجهات تشبيك",
        slug: "ngo_assists_management",
        route: "tashbeek-management",
        icon: "PackageIcon",
      },
    ],
  },
];
